import React from 'react';

export function ChevronDownIcon({ color }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18px'
      height='14px'
      fill='none'
      viewBox='0 0 10 6'
    >
      <path
        stroke={color || '#294254'}
        strokeWidth='2px'
        d='M1 1l4 2.91L9 1'
      ></path>
    </svg>
  );
}

export function CheckMark({ height, width, strokeWidth, color }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '14px'}
      height={height || '12px'}
      fill='none'
      viewBox='0 0 14 12'
    >
      <path
        stroke={color || '#fff'}
        strokeWidth={strokeWidth || '2px'}
        d='M1 5.625l4.875 4.5L13 1.5'
      ></path>
    </svg>
  );
}

export function ArrowRight({ color }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='19px'
      height='13px'
      fill='none'
      viewBox='0 0 19 13'
    >
      <path
        stroke={color || '#fff'}
        strokeWidth='3px'
        d='M11.235 1.273l5.083 4.83-5.083 5.337'
      ></path>
      <path
        stroke={color || '#fff'}
        strokeWidth='3'
        d='M16.327 6.27L0.673 6.27'
      ></path>
    </svg>
  );
}

export function ArrowLeft({ color }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='14'
      fill='none'
      viewBox='0 0 16 14'
    >
      <path
        fill={color || '#2F4660'}
        fillRule='evenodd'
        d='M6.75 1.664A1 1 0 105.257.336L.253 5.965a.997.997 0 00-.251.726.997.997 0 00.25.727l5.004 5.629a1 1 0 101.495-1.329L3.179 7.7H15a1 1 0 100-2H3.164L6.75 1.664z'
        clipRule='evenodd'
      ></path>
    </svg>
  );
}

export function ShowPasswordEye({ color, width, height }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '24px'}
      height={height || '24px'}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        stroke={color || '#818D9B'}
        strokeWidth='1.5'
        d='M2 12.343c3.156-3.334 11.429-10.14 20 0-3.067 4.198-11.893 8.89-20 0z'
      ></path>
      <circle
        cx='12.1'
        cy='12.1'
        r='2.85'
        stroke={color || '#818D9B'}
        strokeWidth='1.5'
      ></circle>
    </svg>
  );
}

export function DontShowPasswordEye({ color, width, height }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '24px'}
      height={height || '24px'}
      fill='none'
      viewBox='0 0 23 19'
    >
      <path
        stroke={color || '#818D9B'}
        strokeWidth='1.5'
        d='M2 9.743c3.156-3.335 11.429-10.14 20 0-3.067 4.198-11.893 8.89-20 0z'
      ></path>
      <circle
        cx='12'
        cy='9.6'
        r='2.85'
        stroke={color || '#818D9B'}
        strokeWidth='1.5'
      ></circle>
      <path
        strokeWidth='.5'
        fill={color || '#818D9B'}
        stroke={color || '#818D9B'}
        d='M19.642 1.294H22.242V23.094H19.642z'
        transform='rotate(48.422 19.642 1.294)'
      ></path>
    </svg>
  );
}

export function HeaderLogo() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='99'
      height='10'
      fill='none'
      viewBox='0 0 99 10'
    >
      <path
        fill='#3B5B80'
        d='M4.986 0c2.778 0 5 2.236 5 5.014a4.967 4.967 0 01-5 4.986A4.956 4.956 0 010 5.014C0 2.236 2.208 0 4.986 0zm0 8.194c1.75 0 3.195-1.43 3.195-3.18 0-1.75-1.445-3.208-3.195-3.208-1.75 0-3.18 1.458-3.18 3.208 0 1.75 1.43 3.18 3.18 3.18zM12.362 8.5l.5-.861a.322.322 0 01.472-.097c.07.041 1.194.86 2.097.86.722 0 1.264-.471 1.264-1.069 0-.708-.597-1.194-1.764-1.666-1.305-.528-2.611-1.361-2.611-3C12.32 1.43 13.237 0 15.445 0c1.417 0 2.5.722 2.778.93.139.084.18.32.083.459l-.528.792c-.11.166-.32.277-.486.166-.11-.07-1.167-.764-1.93-.764-.792 0-1.223.528-1.223.973 0 .652.514 1.097 1.64 1.555 1.346.542 2.902 1.347 2.902 3.139 0 1.43-1.236 2.75-3.194 2.75-1.75 0-2.778-.82-3.056-1.083-.125-.125-.194-.195-.07-.417zM21.667.403c0-.14.125-.264.264-.264h1.291c.153 0 .264.125.264.264v3.68h4.528V.403c0-.14.111-.264.264-.264h1.278c.139 0 .264.125.264.264v9.194a.273.273 0 01-.264.264h-1.278a.264.264 0 01-.264-.264V5.764h-4.528v3.833a.264.264 0 01-.264.264h-1.291a.273.273 0 01-.264-.264V.403zM33.472.403c0-.14.125-.264.264-.264h1.291c.14 0 .264.125.264.264v9.194a.273.273 0 01-.264.264h-1.291a.273.273 0 01-.264-.264V.403zM42.82.403c0-.14.125-.264.264-.264h1.291c.153 0 .264.125.264.264v3.68h4.528V.403c0-.14.111-.264.264-.264h1.278c.139 0 .264.125.264.264v9.194a.273.273 0 01-.264.264H49.43a.264.264 0 01-.264-.264V5.764h-4.528v3.833a.264.264 0 01-.264.264h-1.291a.273.273 0 01-.264-.264V.403zM54.638.403c0-.14.111-.264.264-.264h5.652c.153 0 .264.125.264.264V1.54a.264.264 0 01-.264.264h-4.11v2.278h3.43c.139 0 .264.125.264.264V5.5a.264.264 0 01-.264.264h-3.43v2.43h4.11c.153 0 .264.125.264.264v1.139a.264.264 0 01-.264.264h-5.652a.264.264 0 01-.264-.264V.403zM63.043 9.5l4.32-9.347c.041-.084.11-.153.236-.153h.138c.14 0 .195.07.237.153L72.25 9.5c.084.18-.028.361-.236.361h-1.208c-.209 0-.306-.083-.403-.278l-.68-1.5H65.57l-.68 1.5a.419.419 0 01-.404.278H63.28c-.208 0-.32-.18-.236-.361zm6-2.958l-1.389-3.056h-.042l-1.36 3.056h2.791zM74.722.403c0-.14.112-.264.264-.264h1.278c.139 0 .264.125.264.264v7.791h3.542c.153 0 .264.125.264.264v1.139a.264.264 0 01-.264.264h-5.084a.264.264 0 01-.264-.264V.403zM83.417 1.805h-2.125a.264.264 0 01-.264-.264V.403c0-.14.11-.264.264-.264h6.07c.152 0 .263.125.263.264V1.54a.264.264 0 01-.264.264h-2.125v7.792a.273.273 0 01-.264.264h-1.291a.273.273 0 01-.264-.264V1.805zM90.154.403c0-.14.125-.264.264-.264h1.291c.153 0 .264.125.264.264v3.68h4.528V.403c0-.14.111-.264.264-.264h1.278c.139 0 .264.125.264.264v9.194a.273.273 0 01-.264.264h-1.278a.264.264 0 01-.264-.264V5.764h-4.528v3.833a.264.264 0 01-.264.264h-1.291a.273.273 0 01-.264-.264V.403z'
      ></path>
    </svg>
  );
}

export function CloseIcon({ color, onClick }) {
  return (
    <svg
      onClick={onClick}
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill={color || '#818D9B'}
        d='M1.707.293A1 1 0 00.293 1.707L1.707.293zm12.586 15.414a1 1 0 001.414-1.414l-1.414 1.414zm1.414-14A1 1 0 0014.293.293l1.414 1.414zM.293 14.293a1 1 0 101.414 1.414L.293 14.293zm0-12.586l7 7 1.414-1.414-7-7L.293 1.707zm7 7l7 7 1.414-1.414-7-7-1.414 1.414zm1.414 0l7-7L14.293.293l-7 7 1.414 1.414zM7.293 7.293l-7 7 1.414 1.414 7-7-1.414-1.414z'
      ></path>
    </svg>
  );
}
